import { getActivityFeedStore, getActivityFeedAccountStore } from "./store";
import { isAccountInActivityFeedStore } from "../utils/isAccountInActivityFeedStore";
import selectAccountNotificationStore from "./selectAccountNotificationStore";
import type { MailboxInfo } from "owa-client-types";
import { areNotificationsEnabledForAccount } from "../utils/areNotificationsEnabledForAccount";
import areNotificationsEnabled from "owa-notifications-settings/lib/selectors/areNotificationsEnabled";
import { ActivityType } from "../service/ActivityFeedStorageItem";
import { isGlobalFeatureEnabled } from "owa-feature-flags";

export const getUnseenItemsCount = (): number => {
    const count = 0;
    const store = getActivityFeedStore();
    if (!store.isOpx && (store.isActivityFeedOpen || !areNotificationsEnabled())) {
        return count;
    }
    
    const selectedAccountOptions = selectAccountNotificationStore().selectedAccountOptions;
    if (selectedAccountOptions.size > 0) {
        return Array.from(selectedAccountOptions).reduce((total, mailboxInfo) => total + getUnseenItemsCountForMailbox(mailboxInfo), count);
    }
    
    return count;
};

export const getUnseenItemsCountForMailbox = (mailboxInfo: MailboxInfo): number => {
    let count = 0;
    if (!areNotificationsEnabledForAccount(mailboxInfo)) {
        return count;
    }
    
    // Check if the account has been added to the store since it's possible that OwaSuiteHeader calls
    // this function before a newly added account is initialized in the notifications store.
    if (isAccountInActivityFeedStore(mailboxInfo)) {
        const { items } = getActivityFeedAccountStore(mailboxInfo);
        
        if (isGlobalFeatureEnabled("notif-copilotAgenticNotifications")) {
            // Don't want to count unseen calendar instruction notifications more than once,
            // so we check if there are any unseen calendar instruction notifications and count them as 1,
            // then count the rest of the unseen items as normal.
            let isCalendarInstructionNotificationUnseen = false;
            for (const item of items.values()) {
                if (!item.isSeen) {
                    if (item.type === ActivityType.CalendarInstructionNotification) {
                        isCalendarInstructionNotificationUnseen = true;
                    }
                    else {
                        count++;
                    }
                }
            }
            if (isCalendarInstructionNotificationUnseen) {
                count++;
            }
        }
        else {
            const unseenItems = [...items.values()].filter(item => !item.isSeen);
            count = unseenItems.length;
        }
    }
    return count;
};
